import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseControl } from '../../ui/controls/base-control.model';
import { StackLayoutModule } from '@progress/kendo-angular-layout';
import { FormControlComponent } from '../form-control/form-control.component';
import { GridKendoCardComponent } from '../grid-kendo-card/grid-kendo-card.component';
import { KendoCardFormControlComponent } from '../kendo-card-form-control/kendo-card-form-control.component';

@Component({
    selector: 'app-kendo-card-form-row',
    imports: [StackLayoutModule,
        FormControlComponent,
        ReactiveFormsModule,
        GridKendoCardComponent,
        KendoCardFormControlComponent],
    templateUrl: './kendo-card-form-row.component.html',
    styleUrls: ['./kendo-card-form-row.component.css']
})
export class KendoCardFormRowComponent {

  @Input() controls: BaseControl[];
  @Input() form: FormGroup;
  @Input() submitted: boolean;

  constructor() { }

}
